import React, { useState, useEffect, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import {
  H4,
  DocNote,
  HorizontalSpacer,
  AppstoreOutlined,
  FreeText,
  CaretIcon,
} from 'components';
import { TitleGroup, FilterSection, FilterTitle, ClearAll, CollapseContainer } from './panelStyles';
import { ModelContext } from 'pages/Home/ModelContext';
import { withTheme } from 'styled-components';
import { Category } from './Category';

const Attributes = withTheme(props => {
  const { theme } = props;
  const { getModels } = useContext(ModelContext);
  const userPreferences = useSelector(s => s.userData.userPreferences);
  const filterPanel = userPreferences?.filterPanel;
  const selectedTheme = userPreferences.theme;
  const { mediumGrey, accent } = theme.colors[selectedTheme];

  const [ searchParams, setSearchParams ] = useSearchParams();
  // keep local state in sync with URL
  const [ isFree,   setIsFree ]   = useState(false);
  const [ isPurchased, setIsPurchased ] = useState(false);
  const [ isCollapsed, setIsCollapsed ] = useState(false);

  // whenever URL changes (e.g. back/forward), sync checkboxes
  useEffect(() => {
    setIsFree(searchParams.get('attributes') === 'free_download');
    setIsPurchased(searchParams.get('attributes') === 'can_purchase');
  }, [ searchParams ]);

  const anyChecked = isFree || isPurchased;

  const onClear = () => {
    searchParams.delete('attributes');
    searchParams.set('page', '1');
    setIsFree(false);
    setIsPurchased(false);
    setSearchParams(searchParams);
    getModels();
  };

  const onFreeToggle = (val, setter) => {
    if(val) {
        searchParams.set('attributes', 'free_download');
    } else {
        searchParams.delete('attributes');
    }
    searchParams.set('page', '1');
    setSearchParams(searchParams);
    setter(val);
    getModels();
  };

  return (
    <FilterSection collapsed={filterPanel}>
      <FilterTitle>
        <TitleGroup>
          <AppstoreOutlined isTitleIcon={true} $selectedTheme={selectedTheme} />
          <HorizontalSpacer size={8} />
          <H4>Offers</H4>
          <DocNote path={[ 'filterMyFiles','attributes' ]} top={-1} left={100} />
        </TitleGroup>
         <CollapseContainer onClick={() => setIsCollapsed(!isCollapsed)} >
            <CaretIcon color={mediumGrey} hoverColor={accent} rotate={isCollapsed ? 0 : 180} />
          </CollapseContainer>

        {anyChecked && (
          <ClearAll
            theme={theme}
            $selectedTheme={selectedTheme}
            onClick={onClear}
          >
            Clear all
          </ClearAll>
        )}
      </FilterTitle>
      <FilterSection collapsed={isCollapsed} paddingOffset="0">
        <Category
            isActive={isFree}
            name="Free Models"
            callback={() => onFreeToggle(!isFree, setIsFree)}
            icon={<FreeText width={30} height={30} color='onPrimary' hoverColor={'accent'}/>}
        />
      </FilterSection>
    </FilterSection>
  );
});

export { Attributes };
